import { AudienceParcoursStubPage } from '../../../../components/parcours/AudienceParcoursStubPage';
import { getTravauxTertiaireStub } from '../../../../config/travaux-tertiaire';

export default function TertiaireEcsSolairePage() {
  const parcours = getTravauxTertiaireStub('ecs-solaire');
  if (!parcours) return null;
  return (
    <AudienceParcoursStubPage
      parcours={parcours}
      audienceId="tertiaire"
      segment="travaux"
      segmentLabel="Travaux"
      crossLinks={[
        {
          label: 'CEE BAT-* tertiaire',
          href: '/tertiaire/aides/cee-bat',
          iconName: 'sparkles',
          hint: "Prime CEE pour la fiche BAT-TH-152",
        },
        {
          label: 'Suramortissement art. 39',
          href: '/tertiaire/aides/suramortissement',
          iconName: 'percent',
          hint: 'Déduction fiscale pour chaleur renouvelable',
        },
        {
          label: 'Prêts Bpifrance climat',
          href: '/tertiaire/aides/prets-bpifrance',
          iconName: 'banknote',
          hint: 'Financement du reste à charge',
        },
      ]}
      crossLinksAllLabel="Voir toutes les aides tertiaire"
      crossLinksAllHref="/tertiaire/aides"
    />
  );
}
